import { axiosV2 } from 'interceptors/axios';
import { decryptResponse } from 'utils/token';
import { PaginationResponse } from 'modules/_shared/components/Pagination/Pagination';

export type IncentiveOfferEligibleApiItem = {
  id: string;
  name: string;
  planId: string | null;
  totalUnits: number;
  maximumSaleUnits: number;
  ndPercentage: number;
  fdPercentage: number;
  offerAmount: number;
  soldUnits: number;
  soldAmount: number;
  strikePrice: number;
  retentionPercentage: number;
  netAmount: number;
  saleDate: string | null;
  statusLabel: string;
  statusBadge: string;
};

export type GetIncentiveOfferEligiblesResponse = {
  data: IncentiveOfferEligibleApiItem[];
  pagination: PaginationResponse;
};

export const getIncentiveOfferEligibles = async ({
  incentiveOfferId,
  societyId,
  page = 1,
  items = 10,
  search,
}: {
  incentiveOfferId: string;
  societyId: string;
  page?: number;
  items?: number;
  search?: string;
}): Promise<GetIncentiveOfferEligiblesResponse> => {
  const params: Record<string, string | number> = { societyId, page, items };

  if (search?.trim()) {
    params.search = search.trim();
  }

  const { data } = await axiosV2.get(
    `/incentiveOffers/${incentiveOfferId}/eligibles`,
    {
      params,
    }
  );

  const decodedData = (await decryptResponse(
    data
  )) as GetIncentiveOfferEligiblesResponse;

  return decodedData;
};
